import React from "react";
import "./wallet-discover-page.css";

export default function ApplePayPage() {
  return (
    <div className="main">
    <main className="applePayPage">
      <div className="applePayPage__logo">
        <img className="applePayPage__logo-image" src="/assets/apple-wallet/ApplePayLogo.svg" alt="Apple Pay" />
      </div>
      <h1>Discover Apple Pay</h1>

      <h2>1 Pay quickly and securely</h2>
      <p>Apple Pay lets you make purchases using your iPhone or Apple Watch without needing your physical card.</p>

      <h2>2 How it works</h2>
      <ol>
        <li>Add your gift card to the Wallet app.</li>
        <li>At checkout, select Apple Pay.</li>
        <li>Confirm the payment with Face ID, Touch ID, or your passcode.</li>
      </ol>

      <h2>3 Advantages</h2>
      <ul>
        <li>Fast contactless payments</li>
        <li>Greater privacy and security</li>
        <li>No need to enter card details every time</li>
        <li>Works in merchant stores that participate in the gift card program</li>
      </ul>

      <h2>4 Security</h2>
      <p>Your real card number is not shared with merchants. Apple Pay uses encrypted transaction codes and biometric authentication for protection.</p>

      <h2>5 Compatible devices</h2>
      <ul>
        <li>iPhone</li>
        <li>Apple Watch</li>
      </ul>

      <h2>6 Where you can use it</h2>
      <p>Anywhere that accepts contactless payments or displays the Apple Pay logo at the merchant stores that participate in the gift card program.</p>
      <p>
        You can also read Apple&rsquo;s official English explanation here:{" "}
        <a href="https://www.apple.com/apple-pay/" target="_blank" rel="noopener noreferrer">Apple Pay Official Page</a>
      </p>
    </main>
    </div>
  );
}
